/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

import "../bootstrap";
import "../plugins";
import "../config"; // Import the global config
import Vue from "vue";
import { Model } from "vue-api-query";
import { BModal, VBModal } from "bootstrap-vue";
import ElementUI from "element-ui";
import locale from "element-ui/lib/locale/lang/en";
import VueTelInput from "vue-tel-input";
import VueCurrencyInput from "vue-currency-input";
import * as VueGoogleMaps from "vue2-google-maps";
import UserAccess from "../constants/UserAccess";
import store from "../stores";
import LogRocket from "logrocket";

Vue.prototype.$store = store;
Vue.prototype.$userAccess = UserAccess;
window.Vue = Vue;

// this will load the google maps script to html head
Vue.use(VueGoogleMaps, {
  load: {
    key: process.env.MIX_GOOGLE_MAPS_API_KEY,
    libraries: "places",
  },
  installComponents: true,
});

// inject global axios instance as http client to Model
Model.$http = axios;
window.Vue = Vue;
Vue.prototype.moment = moment;
Vue.prototype._ = _;
Vue.use(ElementUI, { locale });
Vue.use(VueTelInput);
Vue.component("b-modal", BModal);
// Note that Vue automatically prefixes directive names with `v-`
Vue.directive("b-modal", VBModal);

Vue.use(VueCurrencyInput, {
  globalOptions: {
    currency: "AUD",
    precision: 2,
    locale: "en-AU",
  },
});

Vue.prototype.can = function (permission) {
  return (
    window.user_access && window.user_access.permissions.includes(permission)
  );
};
Vue.prototype.is = function (role) {
  return window.user_access && window.user_access.roles.includes(role);
};

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

const files = require.context("./", true, /\.vue$/i);
files
  .keys()
  .map((key) =>
    Vue.component(key.split("/").pop().split(".")[0], files(key).default)
  );

Vue.component("pagination", require("laravel-vue-pagination"));
Vue.component(
  "paginated-table",
  require("../components/PaginatedTable.vue").default
);
Vue.component(
  "google-maps-autocomplete",
  require("../components/GoogleMapsAutocomplete.vue").default
);
Vue.component(
  "signature-pad",
  require("./components/signature-pad/SignaturePad.vue").default
);
Vue.component(
  "draggable-map",
  require("../components/DraggableMap.vue").default
);
Vue.component(
  "client-portal-badge",
  require("../components/ClientPortalBadge.vue").default
);
Vue.component(
  "announcements",
  require("../components/Announcements.vue").default
);

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

const app = new Vue({
  el: "#app",
  store,
});

window.LogRocket = LogRocket;
LogRocket.init(process.env.MIX_LOGROCKET_KEY);
window.userpilotSettings = { token: process.env.MIX_COPILOT_KEY };
